import { Link } from "@components/Link/Link";
import React from "react";
import tw, { styled } from "twin.macro";

import { StyledButton } from "../../Styled/Button";
import { Icon } from "../../Icon";

const StyledIcon = styled(Icon)`
  ${tw`transition-transform group-hover:transform group-hover:translate-x-pico duration-slow pl-micro`}
`;

const Button = styled(StyledButton)`
  ${tw`w-full md:max-w-[300px] z-10 pointer-events-auto`}
  ${({ mobile }) =>
    mobile
      ? tw`flex border-l border-r md:hidden bg-neutral-alt border-neutral`
      : tw`hidden md:flex`}
`;

const HeroButton = ({ children, className, link, mobile }) => (
  <Button
    className={`group ${className}`}
    colour="light"
    height="88-56"
    textSize="32"
    mobile={mobile}
    as={link ? Link : null}
    to={link}
    icon
  >
    {children}
    <StyledIcon name="vintageArrow" size="medium" />
  </Button>
);

export default HeroButton;
